import { Skeleton } from "@/components/ui/skeleton";

interface PageSkeletonProps {
  /** Number of card-sized skeleton blocks */
  cards?: number;
  /** Layout: grid of cards or stacked list */
  layout?: "grid" | "list";
}

export function PageSkeleton({ cards = 4, layout = "grid" }: PageSkeletonProps) {
  return (
    <div className="p-6 md:p-8 space-y-6" aria-busy="true" aria-label="Loading content">
      <div className="space-y-2">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-72" />
      </div>
      {layout === "grid" ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[...Array(cards)].map((_, i) => (
            <Skeleton key={i} className="h-28 rounded-lg" />
          ))}
        </div>
      ) : (
        <div className="space-y-3">
          {[...Array(cards)].map((_, i) => (
            <Skeleton key={i} className="h-20 rounded-lg" />
          ))}
        </div>
      )}
      <Skeleton className="h-64 rounded-lg" />
    </div>
  );
}
